export const SUBMISSION_DIFFICULTY_OPTIONS: Record<string, number[]> = {
  ARCHITECT: [0.8, 0.9, 1, 1.1, 1.2, 1.3],
  LANDSCAPE_ARCHITECT: [0.8, 0.9, 1, 1.1, 1.2, 1.3],
  CIVIL_ENGINEER: [0.8, 0.9, 1, 1.1, 1.2],
  CIVIL_ENGINEER_EXCAVATION: [0.8, 0.9, 1, 1.1, 1.2],
  ENGINEER: [0.8, 0.9, 1, 1.1, 1.2],
  ELECTRICAL: [0.8, 0.9, 1, 1.1, 1.2, 1.3, 1.4],
  HEATING_COOLING: [0.8, 0.9, 1, 1.1, 1.2, 1.3, 1.4],
  VENTILATION_AC: [0.8, 0.9, 1, 1.1, 1.2, 1.3, 1.4],
  HVAC: [0.8, 0.9, 1, 1.1, 1.2, 1.3, 1.4],
  SANITARY: [0.8, 0.9, 1, 1.1, 1.2, 1.3, 1.4],
  BUILDING_AUTOMATION: [0.8, 0.9, 1, 1.1, 1.2, 1.3, 1.4],
  SPECIALIST_COORDINATION: [0.8, 0.9, 1, 1.1, 1.2, 1.3, 1.4],
}

export function getSubmissionDifficultyOptions(role: string): number[] {
  return SUBMISSION_DIFFICULTY_OPTIONS[role] ?? SUBMISSION_DIFFICULTY_OPTIONS.ARCHITECT
}

type SubmissionDifficultySection = 'mainUsage' | 'planningStart' | 'planningEnd'

function getSubmissionDifficultyKey(role: string): string {
  if (role === 'ARCHITECT' || role === 'LANDSCAPE_ARCHITECT') {
    return 'difficultyArchitect'
  }
  if (role === 'ENGINEER' || role === 'CIVIL_ENGINEER' || role === 'CIVIL_ENGINEER_EXCAVATION') {
    return 'difficultyEngineer'
  }
  return 'difficultyTechnical'
}

export function getSubmissionDifficultyLabel(
  role: string,
  wtSummary: (...path: string[]) => string,
  section: SubmissionDifficultySection = 'mainUsage'
): string {
  const key = getSubmissionDifficultyKey(role)
  return wtSummary('projectSubmission', section, key) || wtSummary('projectSubmission', 'mainUsage', key)
}

export function getSubmissionDifficultyAdjustedQuestion(
  role: string,
  wtSummary: (...path: string[]) => string
): string {
  const key =
    role === 'ARCHITECT' || role === 'LANDSCAPE_ARCHITECT'
      ? 'difficultyAdjustedArchitectQuestion'
      : role === 'ENGINEER' || role === 'CIVIL_ENGINEER' || role === 'CIVIL_ENGINEER_EXCAVATION'
        ? 'difficultyAdjustedEngineerQuestion'
        : 'difficultyAdjustedTechnicalQuestion'

  return wtSummary('projectSubmission', 'planningEnd', key)
}
